import { atom } from "recoil";

type FontSizeAtomValue = number;

export const FontSizeAtom = atom<FontSizeAtomValue>({
  key: "FontSizeAtom",
  default: 14,
});
